<template>
  <div class="assets">
    <div class="box is-shadowless">
      <div class="columns is-multiline">
        <div class="column is-7-desktop">
          <assets-map
            :assets="mapAssets"
            :selected.sync="selectedAsset"
            :drawable="mode === $options.modes[1]"
            @draw-created="onMapDrawCreated"
          ></assets-map>
        </div>
        <div class="column is-5-desktop">
          <asset-form
            :nodes="newAssetNodes"
            @save-success="onFormSaveSuccess"
            @cancel="onFormCancel"
            v-if="mode === $options.modes[1]"
          ></asset-form>
          <asset-detail
            :asset="selectedAsset"
            :hotspot.sync="selectedAsset.hotspot"
            v-if="selectedAsset && mode === 'view'"
          ></asset-detail>
          <assets-table
            :checked.sync="checkedAssets"
            :selected.sync="selectedAsset"
            :mode.sync="mode"
            ref="assetsTable"
          ></assets-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AssetsTable from "./partials/table";
import AssetDetail from "./partials/detail";
import AssetForm from "./partials/form";
import AssetsMap from "@/components/AssetsMap";

export default {
  modes: ["view", "create"],
  components: {
    AssetsTable,
    AssetsMap,
    AssetDetail,
    AssetForm
  },
  data: () => ({
    mode: null,
    checkedAssets: [],
    selectedAsset: null,
    newAsset: null
  }),
  computed: {
    mapAssets() {
      let clone = JSON.parse(JSON.stringify(this.checkedAssets));

      if (this.selectedAsset) {
        // Avoid duplicate assets
        if (!clone.find(asset => asset.id === this.selectedAsset.id)) {
          clone.push(this.selectedAsset);
        }
      }

      if (this.newAsset) {
        clone.push(this.newAsset);
      }

      return clone;
    },
    newAssetNodes() {
      return this.newAsset ? this.newAsset.assetNodes : [];
    }
  },
  created() {
    this.mode = this.$options.modes[0];
  },
  methods: {
    onFormCancel() {
      this.mode = this.$options.modes[0];
      this.newAsset = null;
    },
    onFormSaveSuccess() {
      this.mode = this.$options.modes[0];
      this.newAsset = null;
      this.$refs.assetsTable.fetch();
    },
    onMapDrawCreated(event) {
      const layer = event.layer;
      const layerType = event.layerType;
      let asset = {
        new: true,
        options: {
          disabled: true,
          color: "#3273DC"
        }
      };
      let latLngs = [];

      if (layerType === "marker") {
        latLngs = [layer.getLatLng()];
      }

      if (layerType === "polyline") {
        latLngs = layer.getLatLngs();
      }

      if (layerType === "polygon") {
        latLngs = layer.getLatLngs()[0];
      }

      latLngs = latLngs.map(latLng => {
        return {
          latitude: latLng.lat,
          longitude: latLng.lng
        };
      });

      asset.assetNodes = latLngs;

      this.newAsset = asset;
    }
  }
};
</script>

<style lang="scss">
.assets-map {
  height: 88vh;
}
.assets {
  @media only screen and (min-width: 769px) {
    .card-content {
      height: calc(42vh - 44px - 16px);
      padding: 0;
      overflow-y: scroll;
    }
    .assets-create {
      .card-content {
        height: calc(42vh - 44px - 16px - 45px);
        padding: 1.5rem;
      }
    }
    .assets-create,
    .assets-detail {
      margin-bottom: 1.5rem;
    }
    .card-content:hover {
      &::-webkit-scrollbar-thumb {
        background: #ccc;
      }

      &::-webkit-scrollbar-thumb:hover {
        background: #888;
      }
    }
    ::-webkit-scrollbar {
      width: 7px;
      height: 7px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Assets/list/index.vue